export default {
    FeeByUserSender: 1,
    FeeByShare: 2,
    FeeByUserReceiver: 3,
  };